import { render } from "./SeeAssociatesView.vue?vue&type=template&id=3167be01&scoped=true"
import script from "./SeeAssociatesView.vue?vue&type=script&lang=js"
export * from "./SeeAssociatesView.vue?vue&type=script&lang=js"

import "./SeeAssociatesView.vue?vue&type=style&index=0&id=3167be01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3167be01"]])

export default __exports__